<style>
  .pagination a {
    text-decoration: none !important;
  }
  .pagination-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .disabled {
    background-color: #dbdbdb;
    border-color: #dbdbdb;
    box-shadow: none;
    color: #7a7a7a;
    opacity: 0.5;
  }
</style>

<script>
  export let hasNext;
  export let hasPrev;
  export let onNext;
  export let onPrev;
</script>

<div class="pagination-wrapper">
  <nav class="pagination is-centered" role="navigation" aria-label="pagination">
    
    <a 
      class="pagination-previous" 
      class:disabled="{!hasPrev}"
      href="javascript:void(0)" 
      on:click={() => hasPrev && onPrev()}
    >
      Previous
    </a>

    <a 
      class="pagination-next" 
      class:disabled="{!hasNext}"
      href="javascript:void(0)" 
      on:click={() => hasNext && onNext()}
    >
      Next page
    </a>
  </nav>
</div>